import { CRUDApiService } from "./impl/CRUDApiService";

export class FragranceApiService extends CRUDApiService {
  constructor() {
    super('fragrances');
  }
}
